<template>
  <section class="onboarding-steps-wrapper">
    <b-steps
      v-model="activeStep"
      size="is-centered"
      label-position="bottom"
      animated
      rounded
      :has-navigation="false"
      class="onboarding-steps"
      @input="onStepInput"
    >
      <b-step-item label="Intro" icon="account"></b-step-item>
      <b-step-item label="Additional Details" icon="clipboard-text"></b-step-item>
      <b-step-item label="Aspirations" icon="star"></b-step-item>
    </b-steps>
  </section>
</template>

<script>
export default {
  name: 'OnboardingSteps',

  props: {
    currentStep: {
      type: Number,
      required: true,
      validator(value) {
        return Number.isInteger(value) && value >= 1 && value <= 3
      }
    }
  },

  data() {
    return {
      // internal 0-based index used by b-steps
      activeStep: this.toIndex(this.currentStep)
    }
  },

  watch: {
    // Keep internal index in sync when prop changes (convert to 0-based)
    currentStep(newVal) {
      this.activeStep = this.toIndex(newVal)
    }
  },

  methods: {
    // convert 1-based step to 0-based and clamp
    toIndex(stepOneBased) {
      const raw = Number(stepOneBased) - 1
      const maxIndex = 2 // since you have 3 steps; if you later want dynamic, expose stepCount
      if (isNaN(raw)) return 0
      return Math.max(0, Math.min(maxIndex, raw))
    },

    // Called when user clicks a step (b-steps emits new index via @input)
    onStepInput() {
      // Immediately revert to the prop-driven index so clicks don't change anything.
      // Use nextTick to avoid fighting with the internal update cycle.
      this.$nextTick(() => {
        this.activeStep = this.toIndex(this.currentStep)
      })
    }
  },
}
</script>

<style scoped>
.onboarding-steps {
  margin-bottom: 2rem;
}

/* Scoped deep selector to hit the internal step links. Keep it but the onStepInput revert is the strong guarantee. */
:deep(.onboarding-steps .step-link) {
  pointer-events: none !important;
  cursor: default !important;
}

/* Optional: if you still see clickability, use an overlay approach (uncomment and adapt):
.onboarding-steps-wrapper { position: relative; }
.overlay-block {
  position: absolute; inset: 0; z-index: 10; cursor: default;
}
*/
</style>
